export default [{
    path: '/reports/report-by-objects',
    name: 'reports-by-objects',
    component: () => import('@/views/modules/Reports/index.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.report_contracts_by_objects',
        active: true,
      }, ],
      unique_name: "reports-report-by-objects"
    },
  },
  {
    path: '/reports/reports-new',
    name: 'reports-new',
    component: () => import('@/views/modules/Reports/newReport.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.report_contracts_by_objects',
        active: true,
      }, ],
      unique_name: "reports-reports-new"
    },
  },
  {
    path: '/reports/reports-total',
    name: 'reports-total',
    component: () => import('@/views/modules/Reports/totalReport.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.report_contracts_by_objects',
        active: true,
      }, ],
      unique_name: "reports-reports-total"
    },
  },
  {
    path: '/reports/sold-apartments',
    name: 'reports-sold-apartments',
    component: () => import('@/views/modules/Reports/soldApartments.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.reports-sold-apartments',
        active: true,
      }, ],
      unique_name: "reports-sold-apartments"
    },
  },
  {
    path: '/reports/not-sold-apartments',
    name: 'reports-not-sold-apartments',
    component: () => import('@/views/modules/Reports/notSoldApartments.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.reports-not-sold-apartments',
        active: true,
      }, ],
      unique_name: "reports-not-sold-apartments"
    },
  },
  {
    path: '/reports/client-payments',
    name: 'reports-client-payments',
    component: () => import('@/views/modules/Reports/clientPayments.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.reports-client-payments',
        active: true,
      }, ],
      unique_name: "reports-client-payments"
    },
  },
  {
    path: '/reports/on-clients',
    name: 'reports-clients',
    component: () => import('@/views/modules/Reports/onClients.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.reports-clients',
        active: true,
      }, ],
      unique_name: "reports-on-clients"
    },
  },
]